import { BUILTIN_SOURCES } from './BuiltinCatalog.ts';
import { validateProfile } from '../source-engine/ProfileValidator.ts';
import { assertPublicUrl } from '../network/SourceRegistry.ts';
import type { RepoExtension } from './KeiyoushiRepoParser.ts';

/** Data-only repositories: no remote scripts, APKs or executable modules. */
export function parseYomiriRepository(input: unknown): { name: string; extensions: RepoExtension[] } {
  if (!input || typeof input !== 'object') throw new Error('Repositorio inválido.');
  const repo = input as Record<string, unknown>;
  if (!['yomiri.repository.v1', 'yomiri.catalog.v1'].includes(String(repo.format)) || typeof repo.name !== 'string' || !repo.name.trim() ||
      !Array.isArray(repo.sources) || !repo.sources.length || repo.sources.length > 128)
    throw new Error('Repositorio Yomiri inválido.');
  const ids = new Set<string>();
  const extensions = repo.sources.map((raw): RepoExtension => {
    if (repo.format === 'yomiri.catalog.v1' && raw && typeof raw === 'object' && 'connectorId' in raw) {
      const record = raw as Record<string, unknown>;
      const native = BUILTIN_SOURCES.find(source => source.id === record.connectorId && source.type === record.type);
      if (!native || ids.has(native.id)) throw new Error('Conector no admitido o duplicado.');
      ids.add(native.id);
      const iconUrl = typeof record.iconUrl === 'string' ? assertPublicUrl(record.iconUrl).href : new URL('/favicon.ico',native.website).href;
      const language=native.id==='anizone'?'en':'es';
      return { name:native.name,pkg:`yomiri.${native.type}.${native.id}`,apk:'',lang:language,code:1,version:'1.0.0',nsfw:false,iconUrl,sources:[{id:native.id,name:native.name,lang:language,baseUrl:native.website,contentKind:native.type,connectorId:native.id}] };
    }
    const profile = validateProfile(repo.format === 'yomiri.catalog.v1' && raw && typeof raw === 'object' && 'profile' in raw ? (raw as {profile: unknown}).profile : raw);
    if (!/^[a-z0-9._-]{1,100}$/.test(profile.id) || ids.has(profile.id))
      throw new Error('ID duplicado o inválido en el repositorio.');
    ids.add(profile.id);
    assertPublicUrl(profile.baseUrl);
    profile.allowedHosts.forEach(host => assertPublicUrl(`https://${host}/`));
    const iconUrl = profile.ui?.iconUrl ? assertPublicUrl(profile.ui.iconUrl).href :
      new URL('/favicon.ico', profile.baseUrl).href;
    return {
      name: profile.name, pkg: `yomiri.custom.${profile.id}`, apk: '', lang: profile.ui?.languages?.[0] ?? 'es',
      code: 1, version: '1.0.0', nsfw: false, iconUrl,
      sources: [{ id: profile.id, name: profile.name, lang: profile.ui?.languages?.[0] ?? 'es', baseUrl: profile.baseUrl, profile }],
    };
  });
  return { name: repo.name.trim(), extensions };
}
